/** Onboarding 功能统一生效人群判断服务。 */
export interface OnboardingEligibilityService {
    /**
     * 判断当前账号是否满足启动页 onboarding 生效条件。
     * @returns 符合公共受众、入口未展示且首次评估没有历史任务时，等待统一启动延时后返回 true。
     */
    isEligible(): Promise<boolean>;
    /**
     * 判断当前账号是否满足报告页 onboarding 生效条件。
     * @returns 符合公共受众且报告首次评估时最多包含当前任务时，等待统一启动延时后返回 true。
     */
    isReportEligible(): Promise<boolean>;
    /** 在任一 Agent 的入口引导成功激活后，全局记录入口已展示。 */
    markEntryOnboardingSeen(): void;
}

/** Onboarding 生效人群服务的容器标识。 */
export const OnboardingEligibilityService = Symbol('OnboardingEligibilityService');
